/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ndm API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseAlertMessageItem,
  ApiResponseDeviceInfoResponse,
  ApiResponseDeviceInterfaceResponse,
  ApiResponseDeviceSnmpTrapResponse,
  ApiResponseDeviceSysLogResponse,
  ApiResponseDeviceWithPerfResponse,
  ApiResponseTopGroupResponse,
  GetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdParams,
  GetV7NdmDeviceMonitoringDeviceWithPerfParams,
  GetV7NdmDeviceMonitoringInterfaceByDeviceIdParams,
  GetV7NdmDeviceMonitoringSnmptrapByDeviceIdParams,
  GetV7NdmDeviceMonitoringSyslogByDeviceIdParams,
  GetV7NdmDeviceMonitoringTopGroupParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getDeviceAlertMessage
 */
export const getV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleId = (
  deviceId: MaybeRef<string>,
  alertRuleId: MaybeRef<string>,
  params?: MaybeRef<GetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  deviceId = unref(deviceId);
  alertRuleId = unref(alertRuleId);
  params = unref(params);

  return customAxiosInstance<ApiResponseAlertMessageItem>(
    {
      url: `/api/v7/ndm/device/monitoring/alert/${deviceId}/message/${alertRuleId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdQueryKey = (
  deviceId?: MaybeRef<string>,
  alertRuleId?: MaybeRef<string>,
  params?: MaybeRef<GetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdParams>,
) => {
  return [
    'api',
    'v7',
    'ndm',
    'device',
    'monitoring',
    'alert',
    deviceId,
    'message',
    alertRuleId,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  deviceId: MaybeRef<string>,
  alertRuleId: MaybeRef<string>,
  params?: MaybeRef<GetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdQueryKey(
    deviceId,
    alertRuleId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleId>>
  > = ({ signal }) =>
    getV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleId(
      deviceId,
      alertRuleId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(deviceId) && unref(alertRuleId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleId>>,
    TError,
    TData
  >;
};

export type GetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleId>>
>;
export type GetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdQueryError =
  ErrorType<unknown>;

/**
 * @summary getDeviceAlertMessage
 */

export function useGetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleId<
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleId>>,
  TError = ErrorType<unknown>,
>(
  deviceId: MaybeRef<string>,
  alertRuleId: MaybeRef<string>,
  params?: MaybeRef<GetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7NdmDeviceMonitoringAlertMessageByDeviceIdAndAlertRuleIdQueryOptions(
    deviceId,
    alertRuleId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getDeviceInfo
 */
export const getV7NdmDeviceMonitoringDeviceInfoByDeviceId = (
  deviceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  deviceId = unref(deviceId);

  return customAxiosInstance<ApiResponseDeviceInfoResponse>(
    { url: `/api/v7/ndm/device/monitoring/device-info/${deviceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7NdmDeviceMonitoringDeviceInfoByDeviceIdQueryKey = (
  deviceId?: MaybeRef<string>,
) => {
  return ['api', 'v7', 'ndm', 'device', 'monitoring', 'device-info', deviceId] as const;
};

export const getGetV7NdmDeviceMonitoringDeviceInfoByDeviceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceInfoByDeviceId>>,
  TError = ErrorType<unknown>,
>(
  deviceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceInfoByDeviceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7NdmDeviceMonitoringDeviceInfoByDeviceIdQueryKey(deviceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceInfoByDeviceId>>
  > = ({ signal }) =>
    getV7NdmDeviceMonitoringDeviceInfoByDeviceId(deviceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(deviceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceInfoByDeviceId>>,
    TError,
    TData
  >;
};

export type GetV7NdmDeviceMonitoringDeviceInfoByDeviceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceInfoByDeviceId>>
>;
export type GetV7NdmDeviceMonitoringDeviceInfoByDeviceIdQueryError = ErrorType<unknown>;

/**
 * @summary getDeviceInfo
 */

export function useGetV7NdmDeviceMonitoringDeviceInfoByDeviceId<
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceInfoByDeviceId>>,
  TError = ErrorType<unknown>,
>(
  deviceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceInfoByDeviceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7NdmDeviceMonitoringDeviceInfoByDeviceIdQueryOptions(
    deviceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getDeviceListWithPerformance
 */
export const getV7NdmDeviceMonitoringDeviceWithPerf = (
  params: MaybeRef<GetV7NdmDeviceMonitoringDeviceWithPerfParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseDeviceWithPerfResponse>(
    {
      url: `/api/v7/ndm/device/monitoring/device-with-perf`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7NdmDeviceMonitoringDeviceWithPerfQueryKey = (
  params?: MaybeRef<GetV7NdmDeviceMonitoringDeviceWithPerfParams>,
) => {
  return [
    'api',
    'v7',
    'ndm',
    'device',
    'monitoring',
    'device-with-perf',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7NdmDeviceMonitoringDeviceWithPerfQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceWithPerf>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7NdmDeviceMonitoringDeviceWithPerfParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceWithPerf>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7NdmDeviceMonitoringDeviceWithPerfQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceWithPerf>>
  > = ({ signal }) => getV7NdmDeviceMonitoringDeviceWithPerf(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceWithPerf>>,
    TError,
    TData
  >;
};

export type GetV7NdmDeviceMonitoringDeviceWithPerfQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceWithPerf>>
>;
export type GetV7NdmDeviceMonitoringDeviceWithPerfQueryError = ErrorType<unknown>;

/**
 * @summary getDeviceListWithPerformance
 */

export function useGetV7NdmDeviceMonitoringDeviceWithPerf<
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceWithPerf>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7NdmDeviceMonitoringDeviceWithPerfParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringDeviceWithPerf>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7NdmDeviceMonitoringDeviceWithPerfQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getDeviceInterfaces
 */
export const getV7NdmDeviceMonitoringInterfaceByDeviceId = (
  deviceId: MaybeRef<string>,
  params?: MaybeRef<GetV7NdmDeviceMonitoringInterfaceByDeviceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  deviceId = unref(deviceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseDeviceInterfaceResponse>(
    {
      url: `/api/v7/ndm/device/monitoring/interface/${deviceId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7NdmDeviceMonitoringInterfaceByDeviceIdQueryKey = (
  deviceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7NdmDeviceMonitoringInterfaceByDeviceIdParams>,
) => {
  return [
    'api',
    'v7',
    'ndm',
    'device',
    'monitoring',
    'interface',
    deviceId,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7NdmDeviceMonitoringInterfaceByDeviceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringInterfaceByDeviceId>>,
  TError = ErrorType<unknown>,
>(
  deviceId: MaybeRef<string>,
  params?: MaybeRef<GetV7NdmDeviceMonitoringInterfaceByDeviceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringInterfaceByDeviceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7NdmDeviceMonitoringInterfaceByDeviceIdQueryKey(deviceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringInterfaceByDeviceId>>
  > = ({ signal }) =>
    getV7NdmDeviceMonitoringInterfaceByDeviceId(deviceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(deviceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringInterfaceByDeviceId>>,
    TError,
    TData
  >;
};

export type GetV7NdmDeviceMonitoringInterfaceByDeviceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7NdmDeviceMonitoringInterfaceByDeviceId>>
>;
export type GetV7NdmDeviceMonitoringInterfaceByDeviceIdQueryError = ErrorType<unknown>;

/**
 * @summary getDeviceInterfaces
 */

export function useGetV7NdmDeviceMonitoringInterfaceByDeviceId<
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringInterfaceByDeviceId>>,
  TError = ErrorType<unknown>,
>(
  deviceId: MaybeRef<string>,
  params?: MaybeRef<GetV7NdmDeviceMonitoringInterfaceByDeviceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringInterfaceByDeviceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7NdmDeviceMonitoringInterfaceByDeviceIdQueryOptions(
    deviceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getDeviceSnmptrap
 */
export const getV7NdmDeviceMonitoringSnmptrapByDeviceId = (
  deviceId: MaybeRef<string>,
  params: MaybeRef<GetV7NdmDeviceMonitoringSnmptrapByDeviceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  deviceId = unref(deviceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseDeviceSnmpTrapResponse>(
    {
      url: `/api/v7/ndm/device/monitoring/snmptrap/${deviceId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7NdmDeviceMonitoringSnmptrapByDeviceIdQueryKey = (
  deviceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7NdmDeviceMonitoringSnmptrapByDeviceIdParams>,
) => {
  return [
    'api',
    'v7',
    'ndm',
    'device',
    'monitoring',
    'snmptrap',
    deviceId,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7NdmDeviceMonitoringSnmptrapByDeviceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSnmptrapByDeviceId>>,
  TError = ErrorType<unknown>,
>(
  deviceId: MaybeRef<string>,
  params: MaybeRef<GetV7NdmDeviceMonitoringSnmptrapByDeviceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSnmptrapByDeviceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7NdmDeviceMonitoringSnmptrapByDeviceIdQueryKey(deviceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSnmptrapByDeviceId>>
  > = ({ signal }) =>
    getV7NdmDeviceMonitoringSnmptrapByDeviceId(deviceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(deviceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSnmptrapByDeviceId>>,
    TError,
    TData
  >;
};

export type GetV7NdmDeviceMonitoringSnmptrapByDeviceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSnmptrapByDeviceId>>
>;
export type GetV7NdmDeviceMonitoringSnmptrapByDeviceIdQueryError = ErrorType<unknown>;

/**
 * @summary getDeviceSnmptrap
 */

export function useGetV7NdmDeviceMonitoringSnmptrapByDeviceId<
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSnmptrapByDeviceId>>,
  TError = ErrorType<unknown>,
>(
  deviceId: MaybeRef<string>,
  params: MaybeRef<GetV7NdmDeviceMonitoringSnmptrapByDeviceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSnmptrapByDeviceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7NdmDeviceMonitoringSnmptrapByDeviceIdQueryOptions(
    deviceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getDeviceSysLog
 */
export const getV7NdmDeviceMonitoringSyslogByDeviceId = (
  deviceId: MaybeRef<string>,
  params: MaybeRef<GetV7NdmDeviceMonitoringSyslogByDeviceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  deviceId = unref(deviceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseDeviceSysLogResponse>(
    {
      url: `/api/v7/ndm/device/monitoring/syslog/${deviceId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7NdmDeviceMonitoringSyslogByDeviceIdQueryKey = (
  deviceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7NdmDeviceMonitoringSyslogByDeviceIdParams>,
) => {
  return [
    'api',
    'v7',
    'ndm',
    'device',
    'monitoring',
    'syslog',
    deviceId,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7NdmDeviceMonitoringSyslogByDeviceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSyslogByDeviceId>>,
  TError = ErrorType<unknown>,
>(
  deviceId: MaybeRef<string>,
  params: MaybeRef<GetV7NdmDeviceMonitoringSyslogByDeviceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSyslogByDeviceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7NdmDeviceMonitoringSyslogByDeviceIdQueryKey(deviceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSyslogByDeviceId>>
  > = ({ signal }) =>
    getV7NdmDeviceMonitoringSyslogByDeviceId(deviceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(deviceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSyslogByDeviceId>>,
    TError,
    TData
  >;
};

export type GetV7NdmDeviceMonitoringSyslogByDeviceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSyslogByDeviceId>>
>;
export type GetV7NdmDeviceMonitoringSyslogByDeviceIdQueryError = ErrorType<unknown>;

/**
 * @summary getDeviceSysLog
 */

export function useGetV7NdmDeviceMonitoringSyslogByDeviceId<
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSyslogByDeviceId>>,
  TError = ErrorType<unknown>,
>(
  deviceId: MaybeRef<string>,
  params: MaybeRef<GetV7NdmDeviceMonitoringSyslogByDeviceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7NdmDeviceMonitoringSyslogByDeviceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7NdmDeviceMonitoringSyslogByDeviceIdQueryOptions(
    deviceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getTopGroups
 */
export const getV7NdmDeviceMonitoringTopGroup = (
  params: MaybeRef<GetV7NdmDeviceMonitoringTopGroupParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseTopGroupResponse>(
    {
      url: `/api/v7/ndm/device/monitoring/top-group`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7NdmDeviceMonitoringTopGroupQueryKey = (
  params?: MaybeRef<GetV7NdmDeviceMonitoringTopGroupParams>,
) => {
  return [
    'api',
    'v7',
    'ndm',
    'device',
    'monitoring',
    'top-group',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7NdmDeviceMonitoringTopGroupQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringTopGroup>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7NdmDeviceMonitoringTopGroupParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7NdmDeviceMonitoringTopGroup>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7NdmDeviceMonitoringTopGroupQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7NdmDeviceMonitoringTopGroup>>> = ({
    signal,
  }) => getV7NdmDeviceMonitoringTopGroup(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7NdmDeviceMonitoringTopGroup>>,
    TError,
    TData
  >;
};

export type GetV7NdmDeviceMonitoringTopGroupQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7NdmDeviceMonitoringTopGroup>>
>;
export type GetV7NdmDeviceMonitoringTopGroupQueryError = ErrorType<unknown>;

/**
 * @summary getTopGroups
 */

export function useGetV7NdmDeviceMonitoringTopGroup<
  TData = Awaited<ReturnType<typeof getV7NdmDeviceMonitoringTopGroup>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7NdmDeviceMonitoringTopGroupParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7NdmDeviceMonitoringTopGroup>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7NdmDeviceMonitoringTopGroupQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
